<!--
作者：Loong
时间：2022/06/02
-->
<!-- payGateWay [ 支付宝 - 支付跳转 ] -->
<template>

    <div v-html="payGateWay"></div>

</template>

<script>
export default {
    components: { },

    props: [],

    data() {
        return{
            payGateWay: '',
        }
    },

    mounted(){
        let form = this.$route.query.htmlData;
        this.payGateWay = form;
        this.$nextTick(() => {
            document.getElementById('alipaysubmit').submit();
        });
    },
}
</script>


// WEBPACK FOOTER //
// payGateWay.vue?7154a214